function createTimeout(currentStep: number, maxStep: number, interval: number, callback: (currentStep: number) => void) {
    currentStep++
    callback(currentStep);
    if(currentStep<maxStep) {
        setTimeout(() => createTimeout(currentStep, maxStep, interval, callback), interval);
    }
}

export function addInterval(interval: number, steps: number, callback: (currentStep: number) => void) {
    setTimeout(() => createTimeout(0, steps, interval, callback), interval)
};
